import { render, staticRenderFns } from "./ultra-utv.vue?vue&type=template&id=236e84d1&scoped=true"
import script from "./ultra-utv.vue?vue&type=script&lang=js"
export * from "./ultra-utv.vue?vue&type=script&lang=js"
import style0 from "./ultra-utv.vue?vue&type=style&index=0&id=236e84d1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236e84d1",
  null
  
)

export default component.exports